export default {
  OPEN_AVAILABLE: "OPEN_AVAILABLE",
  OPEN_NOT_AVAILABLE: "OPEN_NOT_AVAILABLE",
  OPEN_DELAYED_WEBCALLBACK: "OPEN_DELAYED_WEBCALLBACK",
  NOT_AVAILABLE: "NOT_AVAILABLE",
  CLOSED: "CLOSED",
};
